import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const NoAttemptModal = ({isOpen, toggle}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                NO ATTEMPT NOTIFICATION
                </ModalHeader>
                <ModalBody className=' font-weight-bold'>
                  <h6>Dear Candidate,</h6>
                  <p>You have not attempted any question in the past 3 minutes.</p>
                  <p>Do you need some HELP? Kindly contact an administrator for HELP.</p>
                </ModalBody>
                <ModalFooter>
                {' '}
                <Button color='success' onClick={toggle}>
                    Okay
                </Button>
                </ModalFooter>
            </Modal>
  );
};

export default NoAttemptModal;
